// React
import React from 'react';
// componentes
import Modal from 'components/CustomDialog';
import {useStyles} from './style';
import Estadisticas from './Estadisticas'

export default function ComponenteGenerarInforme (props) {
        const classes = useStyles();

        return (
            <Modal 
                open={props.open}
                fullScreen={props.fullScreen}
                closeModal={props.closeModal}
                iconToolbar={props.iconToolbar}
                titleToolbar={props.titleToolbar}
            >
                <Estadisticas actualizarTabla={props.actualizarTabla} closeModal={props.closeModal} datosEstadisticosNacional={props.datosEstadisticosNacional}/>
            </Modal>
        )
}